import styled, { css } from 'styled-components'
import List from '../List/List'
import Link from '../Links/Link/Link'

export const PrivacyLink = styled(Link)`
  font-size: 1.125rem;
  line-height: 1.6;
  font-weight: 400;
  color: var(--dark);
  text-underline-offset: 3px;

  &:hover {
    text-decoration: none;
    color: var(--dark);
  }
`

export const StyledParagraph = styled.p`
  margin-bottom: 1.25rem;
  font-size: 1.125rem;
  line-height: 1.6;
  margin-top: 0;
  color: var(--light);
`

export const Button = styled.button`
  background-color: transparent;
`

export const FeedbackLink = styled(Link)`
  padding-left: 0;
  color: var(--light);

  span {
    font-size: 1.125rem;
    line-height: 1.78;
  }

  &:hover {
    color: var(--light);
    text-decoration: underline;
    text-underline-offset: 3px;
    svg path {
      fill: var(--light);
    }
  }

  svg path {
    fill: var(--light);
  }
`

export const StyledFooter = styled.div`
  width: 100%;
  position: relative;
`

export const StyledFooterTop = styled.div`
  padding-top: 2.5rem;
  background-color: var(--blue);
`

export const StyledIcon = styled.span`
  margin-right: 0.5rem;
  height: 1.5rem;
  width: 1.5rem;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  svg {
    max-height: 100%;
    height: 100%;
  }
`

export const StyledList = styled(List)<{ $isRow?: boolean }>`
  margin: 0 0 3.5rem;
  li {
    padding-left: 0;
  }
  @media screen and (min-width: 48rem) {
    margin: 0;
  }
  ${({ $isRow }) =>
    $isRow &&
    css`
      margin: 0 0 2.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      li a {
        span {
          margin-right: 1rem;
        }
        span.hrefLink {
          display: none;
          margin-right: 0;
        }
      }
      @media screen and (min-width: 48rem) {
        margin: 0 0 2.5rem;
      }
    `}
`

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  font-size: 1.125rem !important;
  line-height: 1.78 !important;
  color: var(--light);
  text-decoration: none;

  svg,
  span svg path {
    fill: var(--light);
  }

  &:focus,
  &:hover {
    color: var(--light);
    text-decoration: underline;
    text-underline-offset: 3px;
    svg,
    span svg path {
      fill: var(--light);
    }
  }
`

export const StyledRow = styled.div`
  display: flex;
  box-sizing: border-box;
  max-width: 90rem;
  padding: 0 1rem;
  margin: 0 auto;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;

  @media screen and (min-width: 48rem) and (max-width: 94.5rem) {
    padding: 0 2.25rem;
  }

  @media screen and (min-width: 94.5rem) {
    padding: 0;
  }
`

export const StyledFooterBottom = styled.div`
  padding: 1.5rem 0;
  background-color: var(--light);
`
